import React, {useEffect, useState, useContext } from 'react';
import {OrderContext} from "../../context/OrderContext";
import {UserContext} from "../../context/UserContext";
import {
    APIGetOrderAllMessaging,
    APIGetOrderLinkedMessaging,
    APIPostOrderLinkedMessaging
} from "../../api/orders/OrdersMessaging";
import MessageInput from "./messaging/messageInput";
import ChatMessage from './messaging/chatMessage';

export default function OrderMessaging(data) {
    const {order} = useContext(OrderContext);
    const {user} = useContext(UserContext);
    const [message,setMessage] = useState(null);
    const [activities,setActivities] = useState([]);

    const handleUpdate = (e) => {
        setMessage(e.target.value);
    }




    const handleSaveMessage = async () => {
        if(message === null) {
            return;
        }
        const messageData = {
            ordersId : data?.data?.orderId,
            linkId : data?.data?.linkId,
            linkType : data?.data?.linkType,
            createdByUser : user?.id,
            createdByUserName : user?.name,
            createdByCompany : user?.companyId,
            createdByCompanyName : user?.companyId,
            message : message,
            orderCompanyUser: user?.companyId === order?.createdByCompany ? null : order?.createdByUser,
            orderCompany: order?.createdByCompany,
            contractedCompany: order?.contractedCompany,
            planId: order?.planId,
        }
        APIPostOrderLinkedMessaging({messageData, companyId: user.companyId}).then((responseData) => {
            if (responseData === null) {
                return;
            }
            const newActivities = [...activities];
                newActivities.unshift(responseData);
            setActivities(newActivities)
        });
        setMessage(null);
    }


    useEffect(() => {
        const fetchMessages = async () => {
            try {
                let fetchedData;
                if (data?.data?.type === "all") {
                    fetchedData = await APIGetOrderAllMessaging({orderId: data?.data?.orderId, companyId: user?.companyId});
                } else {
                    fetchedData = await APIGetOrderLinkedMessaging({orderId: data?.data?.orderId, linkId: data?.data?.linkId, type: data?.data?.linkType, companyId: user?.companyId});
                }
                setActivities(fetchedData);
            } catch (error) {
            console.error("Error fetching messaging data:", error);
            }

        };

        fetchMessages();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    return (

        <div>

                <div className={'lg:px-6 px-4'}>
                    <div className="sm:px-0 mb-4">
                        <h3 className="font-semibold text-lg text-gray-900">{data?.data?.title}</h3>
                    </div>
                    <div className={"lg:-mx-6 -mx-4"}>

                        <ul className={"scroll-smooth messagingList max-h-[600px] flex flex-col-reverse px-4 overflow-x-hidden overflow-y-auto space-y-6"}>
                            {activities?.map((activityItem) => (
                                <li key={activityItem?.id} className="gap-x-4">
                                    <ChatMessage activityItem={activityItem} />
                                </li>
                            ))}
                        </ul>

                        {(data?.data?.stage !== "completed") && (
                            <MessageInput  message={message} handleUpdate={handleUpdate} handleSaveMessage={handleSaveMessage} />
                        )}
                    </div>
                </div>

        </div>
    );

}